export default __webpack_public_path__ + "static/media/upland@3x.f2de78ce.jpg";